import { render, staticRenderFns } from "./LegalCertificationIndex.vue?vue&type=template&id=a802d792&scoped=true&"
import script from "./LegalCertificationIndex.vue?vue&type=script&lang=js&"
export * from "./LegalCertificationIndex.vue?vue&type=script&lang=js&"
import style0 from "./LegalCertificationIndex.vue?vue&type=style&index=0&id=a802d792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a802d792",
  null
  
)

export default component.exports